import React from 'react';
import { connect } from 'react-redux';

class Layout extends React.Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return state;
}

export default connect(
    mapStateToProps
)(Layout);